<SidebarShell
  :logo="bolide_short_logo"
  :brand_title="brand_name"
  :brand_subtitle="brand_subtitle"
  :initials="initials"
  :full_name="full_name"
  :is_admin="is_admin"
  @brand-click="backToGlobal"
>
  <!-- HEADER ACTIONS -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions" />
  </template>

  <!-- CONTEXT -->
  <template #context>
    <SidebarContext
      :main_label="active_property?.title"
      :sub_label="active_property?.description"
      :items="propertiesFormatted"
      :active_id="active_property?.id"
      :open="dropdownOpen"
      @toggle="toggleDropdown"
      @select="switchProperty"
    >
      <template #top>
        <div
          v-if="can_access_portfolio"
          class="sidebar-context-top border-bottom border-secondary pb-2 mb-2 cursor-pointer"
          @click="backToGlobal"
        >
          <p class="text-white fw-light text-xs mb-2">
            {{ entity_name }}
          </p>
          <p class="text-white-50 fw-light text-xxs mb-0">
            {{ entity_subtitle }}
          </p>
        </div>
      </template>
    </SidebarContext>
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="sidebar-menu px-3 mt-3 w-100">
      <!-- DYNAMIC MENU ITEMS -->
      <div
        v-for="item in menuItems"
        :key="item.key"
        class="sidebar-menu-item d-flex align-items-center py-2 ps-2 rounded w-100 cursor-pointer"
        :class="[
          active_menu_item === item.key
            ? 'bg-dark text-white border-start border-3 border-primary'
            : 'text-white-50 hover-bg-dark'
        ]"
        :aria-label="item.label"
        @click="selectPropertyMenuItem(item.key)"
      >
        <!-- CUSTOM LOGO -->
        <template v-if="item.icon === 'custom'">
          <img
            :src="item.logo"
            :alt="item.label"
            class="sidebar-menu-icon sidebar-logo-icon me-2 cursor-pointer"
          />
        </template>

        <!-- NORMAL ICON -->
        <template v-else>
          <i
            :class="[
              item.icon,
              'sidebar-menu-icon',
              'me-2',
              'cursor-pointer',
              active_menu_item === item.key ? 'text-white' : 'text-white-50'
            ]"
            :aria-label="item.label"
          ></i>
        </template>

        <!-- LABEL -->
        <p class="sidebar-menu-label sidebar-menu-text fw-semibold text-xs mb-0 cursor-pointer">
          {{ item.label }}
        </p>
      </div>
    </div>
  </template>

  <!-- ✅ AFTER MENU (NOW LEGAL) -->
  <template #after-menu>
    <div class="sidebar-after-menu px-3 mt-4">
      <hr class="border-secondary opacity-50 mb-2" />

      <p class="sidebar-after-menu-title text-white-50 text-xxs mb-2">
        WORKFLOW AUTOMATION
      </p>

      <div
        class="sidebar-after-menu-item d-flex align-items-center justify-content-between ps-3 mb-2 not-clickable"
        aria-label="Voice Commands & Tasking"
      >
        <div class="sidebar-after-menu-copy d-flex align-items-center">
          <i class="bi bi-arrow-return-right text-white-50 me-2"></i>
          <p class="sidebar-after-menu-text text-white-50 text-xs mb-0">
            Voice Commands &amp; Tasking
          </p>
        </div>

        <span class="sidebar-after-menu-badge badge bg-warning text-dark fw-bold rounded-pill px-2 py-1 text-xxs">
          BETA
        </span>
      </div>
    </div>
  </template>
</SidebarShell>
